import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import styles from "./game.module.scss";
import promotionTicket from "../../../assets/images/promotionTicket.png";
import hexDownFade from "../../../assets/images/hexDownFade.svg";
import hexUpFade from "../../../assets/images/hexUpFade.svg";
import hexActive from "../../../assets/images/hexActive.svg";
import hexWrong from "../../../assets/images/hexWrong.svg";
import hexRight from "../../../assets/images/hexRight.svg";
import hexDef from "../../../assets/images/hexDef.svg";
import hexJackpot from "../../../assets/images/jackpotBorder.png";
import hexfade from "../../../assets/images/hexFade.svg";
import HowToPlayPop from "../../../components/Modals/HowToPlay";
import trophy from "../../../assets/images/trophy.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showToast, wait } from "../../../helper/common";
import {
  gameComplete,
  stopGame,
  gameStart,
  getUserProfile,
  jackpotAmount,
  leaderBoardUpdate,
} from "../../../lib/store/actions";
import LoaderCstm from "../../../components/Loader";
import CongratulationPop from "../../../components/Modals/congratulationPop";
import { useGameContext } from "../../../context/GameContext";
import useNetworkState from "../../../hooks/useNetworkState";
import useSocket from "../../../hooks/useSocket";
import WelcomeBonusPop from "../../../components/Modals/welcomeBonusPop";
import ClaimBonusPop from "../../../components/Modals/claimBonusPop";
import PromotionBonusPop from "../../../components/Modals/promotionBonusPop";
import PromotionCongratsPop from "../../../components/Modals/promotionCongratsPop";
import EnergyPackagePop from "../../../components/Modals/EnergyPackagePop";
import usePageVisibility from "../../../hooks/useVisibilityDetection";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";

const Game = () => {
  const t = useLanguage();
  const {
    game,
    setGame,
    isGameStart,
    setGameStart,
    isLoading,
    setIsLoading,
    resetGame,
    setGameEnergyLeft,
    setBtncBalance,
    playSound,
    gameEnergyLeft,
    buy,
    setBuy,
  } = useGameContext();
  const navigate = useNavigate();
  const elementRef = useRef(null);
  const [hasWonJackpot, setHasWonJackpot] = useState(false);
  const [height, setHeight] = useState(0);
  const [playInst, setPlayInst] = useState();
  const [congrats, setCongrats] = useState(false);
  const { user: userData } = useSelector(({ Auth }) => Auth);
  const { jackpotAmountDetails } = useSelector(({ Jackpot }) => Jackpot);
  const [refresh, setRefresh] = useState(false);
  const [gameUpdateLoading, setGameUpdateLoading] = useState(false);
  const { settings } = useSelector(({ Settings }) => Settings);
  const { loading } = useSelector(({ Game }) => Game);
  const [cryptoWinningCong, setCryptoWinningCong] = useState(null);
  const [scrollToNum, setScrollToNum] = useState(1);
  const [initialScrollCount, setInitialScrollCount] = useState(0);
  const [isToastActive, setIsToastActive] = useState(false);
  const [forceStopClick, setForceStopClick] = useState(false);
  const [totalBTNC, setTotalBTNC] = useState(0);
  const [showWelcomeBonus, setShowWelcomeBonus] = useState(false);
  const [closedWelcomeBonus, setCloseWelcomeBonus] = useState(false);
  const [showClaimBonus, setShowClaimBonus] = useState(false);
  const [showPackages, setShowPackages] = useState(false);
  const [showPromotionBonus, setShowPromotionBonus] = useState(false);
  const [showPromotionCongrats, setShowPromotionCongrats] = useState(false);
  const [promotionWinningCong, setPromotionWinningCong] = useState(null);

  const dispatch = useDispatch();
  const network = useNetworkState();
  const { socket, socketConnect } = useSocket();

  const isClickExecuting = useRef(false);
  const isClickStartBtn = useRef(false);
  const isStopExecuting = useRef(false);
  const prevEnergyRef = useRef(null);
  const ENERGY_POPUP_KEY = "energyPopupShown";

  const isVisible = usePageVisibility();

  useEffect(() => {
    if (isVisible) {
      const pendingPayment = localStorage.getItem("pendingPayment");
      if (pendingPayment) {
        const payment = JSON.parse(pendingPayment);
        navigate(`/payments?order_id=${payment?.order_id}`);
      }
    }
  }, [isVisible, navigate]);

  // FIXED: Add socket reconnection check when page becomes visible
  useEffect(() => {
    if (isVisible && !socketConnect && socket) {
      // If your socket library supports reconnection, uncomment the line below:
      // socket.connect();
    }
  }, [isVisible, socketConnect, socket]);

  // FIXED: Add cleanup on unmount to prevent race conditions
  useEffect(() => {
    return () => {
      if (isClickStartBtn.current) {
        isClickStartBtn.current = false;
      }
      if (isClickExecuting.current) {
        isClickExecuting.current = false;
      }
      if (isStopExecuting.current) {
        isStopExecuting.current = false;
      }
    };
  }, []);

  // ✅ Clear the popup flag when energy is restored
  useEffect(() => {
    if (gameEnergyLeft > 0) {
      localStorage.removeItem(ENERGY_POPUP_KEY);
    }
  }, [gameEnergyLeft]);

  async function getGameSocketData(data) {
    return new Promise((resolve, reject) => {
      socket.emit("getGameData", data, (res) => {
        if (res?.status) {
          resolve(res);
        } else {
          resolve(null);
        }
      });
    });
  }

  function assignAndScroll(idNumber) {
    try {
      setTimeout(() => {
        const section = document.getElementById(`number-${idNumber}`);
        const container = document.getElementById("game-contain");

        if (section && container) {
          const sectionRect = section.getBoundingClientRect();
          const viewportHeight = container.clientHeight;

          const isFullyVisible =
            sectionRect.top >= 100 && sectionRect.bottom <= viewportHeight;

          if (!isFullyVisible) {
            section.style.scrollMarginTop = "80px";
            section.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        } else {
          console.warn(`Retrying scroll to section ${idNumber}`);
          setTimeout(() => assignAndScroll(idNumber), 200);
        }
      }, 100);
    } catch (err) {
      console.error("Error scrolling to section:", err);
    }
  }

  useEffect(() => {
    if (game) {
      if (initialScrollCount > 1) {
        return;
      }
      setTimeout(() => {
        setInitialScrollCount((pre) => pre + 1);
        assignAndScroll(game?.lineCount || 1);
        setScrollToNum(game?.lineCount || 1);
      }, 1000);
    }
  }, [game, initialScrollCount]);

  useEffect(() => {
    dispatch(
      jackpotAmount({
        data: {},
        callBack: (err, res) => {
          if (err) return;
        },
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getUserProfile({
        data: { _id: userData?._id },
        callBack: (err, res) => {
          if (err) return;
        },
      }),
    );
  }, [dispatch, userData?._id]);

  useEffect(() => {
    if (userData?.currentJackpot) {
      navigate("/jackpot");
    }
  }, [navigate, userData?.currentJackpot]);

  useEffect(() => {
    if (gameEnergyLeft > 0) {
      console.error(gameEnergyLeft, "logCheck");
      setBuy(false);
    }
  }, [gameEnergyLeft]);

  const startGame = async (e) => {
    try {
      e?.preventDefault();
      await wait(200);

      if (isClickStartBtn.current) return;
      isClickStartBtn.current = true;

      if (loading || isLoading || gameUpdateLoading || isGameStart) {
        isClickStartBtn.current = false;
        return;
      }

      if (gameEnergyLeft === 0) {
        setBuy(true);
        return;
      }

      if (!network?.online) {
        if (!isToastActive) {
          setIsToastActive(true);
          showToast(t("toast.please_check_internet_connection"), "error");
          setTimeout(() => {
            setIsToastActive(false);
          }, 3000);
        }
        isClickStartBtn.current = false;
        return;
      }

      if (!socketConnect) {
        showToast(
          `${t("toast.reconnecting")} ${t("toast.please_try_again")}`,
          "info",
        );
        isClickStartBtn.current = false;
        return;
      }

      resetGame();
      assignAndScroll(1);
      setIsLoading(true);
      setGameStart(true);
      setHasWonJackpot(false); // ✅ NEW: Reset jackpot flag

      const gameStartPromise = new Promise((resolve, reject) => {
        dispatch(
          gameStart({
            data: {},
            callBack: async (err, res) => {
              if (err?.message === "canceled") {
                reject(new Error("canceled"));
                return;
              }
              if (err) {
                reject(err);
                return;
              }
              resolve(res);
            },
          }),
        );
      });

      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error("Request timeout")), 10000);
      });

      const res = await Promise.race([gameStartPromise, timeoutPromise]);

      if (res?.user) {
        setGameEnergyLeft(res?.user?.energyBalance);
      }

      setGameStart(true);
      setForceStopClick(false);

      if (!res?.data) {
        setIsLoading(false);
        isClickStartBtn.current = false;
        return;
      }

      let updatedData = { ...res.data, gameData: [], lineData: [] };
      updatedData = {
        ...updatedData,
        gameData: res?.data?.gameData?.reverse(),
        lineData: res?.data?.lineData?.reverse(),
      };

      playSound("startround");
      setGame(updatedData);
      assignAndScroll(1);
      setScrollToNum(1);
      setIsLoading(false);
    } catch (err) {
      console.error("Error starting game:", err);

      setIsLoading(false);
      setGameStart(false);
      assignAndScroll(1);
      setScrollToNum(1);

      if (err.message === "Request timeout") {
        showToast(
          `${t("toast.request_timed_out")} ${t("toast.please_try_again")}`,
          "error",
        );
      } else if (err.message !== "canceled") {
        showToast(
          `${t("toast.failed_to_start_game")} ${t("toast.please_try_again")}`,
          "error",
        );
      }
    } finally {
      setTimeout(() => {
        isClickStartBtn.current = false;
      }, 1500);
    }
  };

  const handleEndGame = async (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    if (isStopExecuting.current) return;

    isStopExecuting.current = true;

    try {
      if (!network?.online) {
        if (!isToastActive) {
          setIsToastActive(true);

          showToast(t("toast.please_check_internet_connection"), "error");

          setTimeout(() => {
            setIsToastActive(false);
          }, 3000);
        }

        return;
      }

      if (loading || isLoading || gameUpdateLoading) {
        return;
      }

      setIsLoading(true);

      let copyUpdatedGame = { ...game };

      const stopGameResponse = await new Promise((resolve, reject) => {
        dispatch(
          stopGame({
            data: {
              _id: game?._id,
            },
            callBack: (err, res) => {
              if (err) {
                reject(err);
                return;
              }
              resolve(res);
            },
          }),
        );
      });

      try {
        const leaderboardResponse = await new Promise((resolve, reject) => {
          dispatch(
            leaderBoardUpdate({
              data: {
                _id: game?._id,
              },

              callBack: (err, res) => {
                if (err) {
                  reject(err);
                  return;
                }

                resolve(res);
              },
            }),
          );
        });
      } catch (leaderboardErr) {
        console.error("Leaderboard API Failed:", leaderboardErr);
      }

      copyUpdatedGame.lineData = [
        ...(stopGameResponse?.gameHistory?.lineData || []),
      ].reverse();

      const gameDataUpdateClick = copyUpdatedGame.lineData.map((item) => ({
        ...item,
        isClicked: true,
      }));

      copyUpdatedGame.lineData = gameDataUpdateClick;

      setGameEnergyLeft(stopGameResponse?.data?.energyBalance);

      setBtncBalance(stopGameResponse?.data?.btncBalance);

      setGame(copyUpdatedGame);

      if (stopGameResponse?.data?.energyBalance === 0) {
        setBuy(true);
      }

      setRefresh((prev) => !prev);

      assignAndScroll(1);
      setScrollToNum(1);
      setGameStart(false);
    } catch (err) {
      console.error("Error stopping game:", err);

      if (parseInt(err?.status_code) === 406) {
        setGameStart(false);

        resetGame();

        assignAndScroll(1);

        setScrollToNum(1);
      }
    } finally {
      setIsLoading(false);

      isStopExecuting.current = false;
    }
  };

  const claimBtncs = async (
    needToEnd,
    updatedGame,
    type,
    isSuccessfulCompletion = false,
  ) => {
    setIsLoading(true);
    try {
      let copyUpdatedGame = { ...updatedGame };
      handleManualRecalculate();

      dispatch(
        gameComplete({
          data: {
            _id: copyUpdatedGame?._id,
            type: isSuccessfulCompletion ? "complete" : "bomb",
          },
          callBack: (err, res) => {
            if (err?.message === "canceled") {
              return;
            }
            if (err) {
              if (parseInt(err?.status_code) === 406) {
                resetGame();
                setGameStart(false);
                assignAndScroll(1);
                setScrollToNum(1);
                return;
              }
              return;
            }

            copyUpdatedGame.lineData = res?.gameHistory?.lineData?.reverse();
            let gameDataUpdateClick = [];
            for (var i = 0; i < copyUpdatedGame.lineData.length; i++) {
              gameDataUpdateClick.push({
                ...copyUpdatedGame.lineData[i],
                isClicked: true,
              });
            }
            copyUpdatedGame.lineData = gameDataUpdateClick;
            setGameEnergyLeft(res?.data?.energyBalance);
            setBtncBalance(res?.data?.btncBalance);
            setGame(copyUpdatedGame);
            setRefresh(!refresh);
            setGameStart(false);
            setIsLoading(false);
            calculateTotalBTNC();
            if (res?.data?.energyBalance === 0) {
              setBuy(true);
            }
          },
        }),
      );
    } catch (err) {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    if (game && elementRef.current) {
      setHeight(elementRef.current.clientHeight);
    }
  }, [game]);

  const handleClick = async (rowIndex, rowItemIndex, game) => {
    try {
      if (isClickExecuting.current) {
        console.warn("Click already executing");
        return;
      }
      isClickExecuting.current = true;

      if (!game?.roundId) {
        console.warn(" No roundId");
        return;
      }

      if (!socketConnect) {
        console.error("Socket not connected");
        if (!isToastActive) {
          setIsToastActive(true);
          showToast(t("toast.connection_lost"), "error");
          setTimeout(() => setIsToastActive(false), 3000);
        }
        return;
      }

      if (!network?.online) {
        console.error(" Network offline");
        if (!isToastActive) {
          setIsToastActive(true);
          showToast(t("toast.please_check_internet_connection"), "error");
          setTimeout(() => setIsToastActive(false), 3000);
        }
        return;
      }

      if (forceStopClick) {
        console.error("Force stop active");
        return;
      }

      // ✅ NEW: Check if jackpot was won
      if (hasWonJackpot) {
        console.warn("Jackpot won, navigation in progress");
        return;
      }

      if (!game?._id) {
        console.error(" No game ID");
        return;
      }

      if (isLoading) {
        console.warn("Already loading");
        return;
      }

      if (!isGameStart) {
        console.warn("Game not started");
        return;
      }

      let item = await getGameSocketData({
        roundId: game?.roundId,
        lineCount: game?.lineCount + 1,
        column: rowItemIndex + 1,
      });

      if (!item) return;

      let clickedItem = item?.lineData?.row?.filter((row) => row?.isOpened);
      clickedItem = clickedItem[0];

      if (clickedItem.valueType === "bomb") {
        playSound("bombendgame");
        setForceStopClick(true);
        let updatedGame = { ...game };
        let updatedGameData = updatedGame.lineData;

        updatedGameData = updatedGameData?.map((pitem, index) => {
          let uItem = { ...pitem };
          if (index === rowIndex) {
            return { ...uItem, ...item.lineData };
          }
          return pitem;
        });

        updatedGame.lineData = updatedGameData;
        setRefresh(!refresh);

        updatedGame.lineCount = updatedGame.lineCount + 1;
        setGame(updatedGame);
        claimBtncs(2, updatedGame, "bomb", false);
      } else {
        if (clickedItem?.valueType === "jackpot") {
          playSound("jackpotopen");
        } else if (clickedItem?.lineCount % 2 === 0) {
          playSound("diamondevenline");
        } else {
          playSound("diamondoddline");
        }

        let updatedGame = { ...game };
        let updatedGameData = updatedGame.lineData;
        updatedGameData = updatedGameData?.map((pitem, index) => {
          let uItem = { ...pitem };
          if (index === rowIndex) {
            return { ...uItem, ...item.lineData };
          }
          return uItem;
        });
        updatedGame.lineData = updatedGameData;
        let WinningItem = updatedGameData[rowIndex].row[rowItemIndex];
        updatedGame.winnings = item.winnings;
        updatedGame.lineCount = updatedGame.lineCount + 1;

        setGame(updatedGame);
        assignAndScroll(scrollToNum + 1);
        setScrollToNum(scrollToNum + 1);

        if (
          WinningItem.coinSymbol !== "BTNC" &&
          WinningItem.coinSymbol !== "bomb" &&
          WinningItem.coinSymbol !== "J"
        ) {
          setCongrats(true);
          setCryptoWinningCong({
            name: WinningItem.coinName,
            symbol: WinningItem.coinSymbol,
            icon: WinningItem.coinIcon,
            amount: WinningItem.value,
          });
        } else if (WinningItem.coinSymbol && WinningItem.coinSymbol === "J") {
          // ✅ NEW: Set jackpot won flag to prevent further clicks
          setHasWonJackpot(true);
          setForceStopClick(true); // Also set force stop to be extra safe

          sessionStorage.setItem("allowNewJackpot", "true");
          setTimeout(() => {
            navigate("/jackpot");
          }, 1000);
        }

        const needToEnd =
          parseInt(updatedGame.lineCount) === updatedGame.lineData?.length;

        if (needToEnd) {
          claimBtncs(2, updatedGame, "crypto", true);
        }
      }
    } catch (err) {
      console.error("Error inside game", err);
    } finally {
      isClickExecuting.current = false;
    }
  };

  const onFinishCongrats = () => {
    setCryptoWinningCong(null);
    setCongrats(false);
  };

  const onFinishPromotionCongrats = () => {
    setPromotionWinningCong(null);
    setShowPromotionCongrats(false);
    dispatch(
      getUserProfile({
        data: { _id: userData?._id },
        callBack: (err, res) => {
          if (err) return;
        },
      }),
    );
  };

  const onFinishPromotionBonus = (data) => {
    setPromotionWinningCong(data);
    setShowPromotionCongrats(true);
    setShowPromotionBonus(false);
    dispatch(
      getUserProfile({
        data: { _id: userData?._id },
        callBack: (err, res) => {
          if (err) return;
        },
      }),
    );
  };

  const calculateTotalBTNC = useCallback(() => {
    return game?.winnings?.reduce((total, currentItem) => {
      if (
        currentItem &&
        currentItem.symbol === "BTNC" &&
        typeof currentItem.amount === "number"
      ) {
        return total + currentItem.amount;
      }
      return total;
    }, 0);
  }, [game?.winnings]);

  useEffect(() => {
    const total = calculateTotalBTNC();
    setTotalBTNC(total);
  }, [calculateTotalBTNC]);

  const handleManualRecalculate = () => {
    setTotalBTNC(0);
  };

  const onFinishWelcomeBonus = () => {
    setCloseWelcomeBonus(true);
    setShowWelcomeBonus(false);
    dispatch(
      getUserProfile({
        data: { _id: userData?._id },
        callBack: (err, res) => {
          if (err) return;
        },
      }),
    );
  };

  const onFinishClaimBonus = () => {
    setShowClaimBonus(false);
    setShowWelcomeBonus(false);
    dispatch(
      getUserProfile({
        data: { _id: userData?._id },
        callBack: (err, res) => {
          if (err) return;
        },
      }),
    );
  };

  useEffect(() => {
    document.body.classList.add("includeHeader");

    return () => {
      document.body.classList.remove("includeHeader");
    };
  }, []);

  const redirectToLeaderBorad = () => {
    if (settings?.leaderboard?.leaderboardStatus === "active") {
      navigate("/leaderboard");
    } else {
      if (!isToastActive) {
        setIsToastActive(true);
        showToast(t("toast.leaderboard_not_active"), "info");
        setTimeout(() => {
          setIsToastActive(false);
        }, 3000);
      }
    }
  };

  const openPopup = () => {
    if (
      settings?.promotionBonus?.status === "enabled" &&
      userData?.claimedScratcherCode === false
    ) {
      setShowPromotionBonus(true);
    } else {
      if (!isToastActive) {
        setIsToastActive(true);
        showToast(t("toast.already_claimed_award"), "info");
        setTimeout(() => {
          setIsToastActive(false);
        }, 2000);
      }
    }
  };

  function hasBombOpened(object) {
    return object?.row?.some(
      (item) => item.isOpened === true && item.valueType === "bomb",
    );
  }

  useEffect(() => {
    let timeoutId;
    if (
      settings?.welcomeBonus?.status === "enabled" &&
      userData?.claimedVerificationBonus === false &&
      userData?.linkedWithBitanica === false &&
      !showPromotionBonus &&
      !showPromotionCongrats &&
      !closedWelcomeBonus
    ) {
      timeoutId = setTimeout(() => {
        setShowWelcomeBonus(true);
      }, 3000);
    } else {
      setShowWelcomeBonus(false);
      setShowClaimBonus(false);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [
    settings,
    userData,
    showPromotionBonus,
    showPromotionCongrats,
    closedWelcomeBonus,
  ]);

  useEffect(() => {
    if (userData?.currentGame?.lineData && !isClickExecuting.current) {
      let data = JSON.parse(
        JSON.stringify(userData?.currentGame?.lineData || []),
      );
      const sortedData = data.sort((a, b) => a.lineCount - b.lineCount);
      const clickedItems = sortedData.filter((item) => item.isClicked);
      const lastClickedItem = clickedItems[clickedItems.length - 1];
      if (lastClickedItem) {
        const bombOpened = hasBombOpened(lastClickedItem);
        if (bombOpened) {
          claimBtncs("", userData?.currentGame, "", false);
        }
      }
    }
  }, [userData?.currentGame]);

  return (
    <>
      <WelcomeBonusPop
        showWelcomeBonus={showWelcomeBonus}
        setShowWelcomeBonus={setShowWelcomeBonus}
        showClaimBonus={showClaimBonus}
        setShowClaimBonus={setShowClaimBonus}
        id={userData?._id}
        onFinish={() => onFinishWelcomeBonus()}
      />

      <ClaimBonusPop
        showWelcomeBonus={showWelcomeBonus}
        setShowWelcomeBonus={setShowWelcomeBonus}
        showClaimBonus={showClaimBonus}
        setShowClaimBonus={setShowClaimBonus}
        onFinish={() => onFinishClaimBonus()}
      />

      <EnergyPackagePop
        showPackages={showPackages}
        setShowPackages={setShowPackages}
      />

      <CongratulationPop
        winningData={cryptoWinningCong}
        congrats={congrats}
        setCongrats={setCongrats}
        onFinish={() => onFinishCongrats()}
      />

      <PromotionCongratsPop
        winningData={promotionWinningCong}
        showPromotionCongrats={showPromotionCongrats}
        setShowPromotionCongrats={setShowPromotionCongrats}
        onFinish={() => onFinishPromotionCongrats()}
      />

      <PromotionBonusPop
        showPromotionBonus={showPromotionBonus}
        setShowPromotionBonus={setShowPromotionBonus}
        showPromotionCongrats={showPromotionCongrats}
        setShowPromotionCongrats={setShowPromotionCongrats}
        id={userData?._id}
        onFinish={(data) => onFinishPromotionBonus(data)}
      />

      <HowToPlayPop playInst={playInst} setPlayInst={setPlayInst} />
      {isLoading && <LoaderCstm />}
      <section className={`${styles.gameSec} gameSec position-relative `}>
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <ul
                className={`${styles.typesCardWrpper} list-unstyled ps-0 mb-0 d-flex gap-10`}
              >
                <li className="w-100">
                  <div className={`${styles.cardCstm} p-1 text-center`}>
                    <h5 className="m-0 fw-bold">{t("game_page.grand")}</h5>
                    <p className="m-0 text-white">
                      $ {jackpotAmountDetails?.grandAmount || 0}
                    </p>
                  </div>
                </li>
                <li className="w-100">
                  <div className={`${styles.cardCstm} p-1 text-center`}>
                    <h5 className="m-0 fw-bold">{t("game_page.major")}</h5>
                    <p className="m-0 text-white">
                      $ {jackpotAmountDetails?.majorAmount || 0}
                    </p>
                  </div>
                </li>
                <li className="w-100">
                  <div className={`${styles.cardCstm} p-1 text-center`}>
                    <h5 className="m-0 fw-bold">{t("game_page.minor")}</h5>
                    <p className="m-0 text-white">
                      $ {jackpotAmountDetails?.minorAmount || 0}
                    </p>
                  </div>
                </li>
              </ul>
              <div
                id="game-contain"
                className={`${styles.gameBoxWrpper} gameBoxWrpper allow-scroll`}
              >
                <div className={`${styles.gameBox} w-100`}>
                  <div className="d-flex align-items-center gap-10">
                    <ul
                      className={`${styles.countList} d-none list-unstyled ps-0 mb-0 position-relative`}
                    >
                      {game?.lineData &&
                        game?.lineData.length > 0 &&
                        game?.lineData.map((item, key) => (
                          <li
                            key={key}
                            className={`${styles.level} ${
                              (!item?.isClicked &&
                                game?._id &&
                                game?.lineData &&
                                game?.lineData?.length -
                                  1 -
                                  game?.lineCount) === key && styles.active
                            } d-flex align-items-center`}
                            style={{ height: height / 1.23, gap: 8 }}
                          >
                            <span
                              className=" fw-bold position-relative"
                              style={{ width: 20 }}
                            >
                              {game?.lineData?.length - key}
                            </span>
                            <span className="icn">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="4"
                                height="4"
                                viewBox="0 0 4 4"
                                fill="none"
                              >
                                <rect
                                  x="0.000244141"
                                  width="4"
                                  height="4"
                                  rx="2"
                                  fill="#506380"
                                />
                              </svg>
                            </span>
                          </li>
                        ))}
                    </ul>

                    <ul
                      className={`${styles.gameOptionWrp} list-unstyled ps-0 mb-0`}
                    >
                      <li
                        className="position-relative pe-0 d-flex align-items-center justify-content-center"
                        style={{
                          opacity: 0.5,
                          paddingLeft: 40,
                          paddingBottom: 12,
                          marginTop: -40,
                        }}
                      >
                        <div
                          className={`${styles.listCount} opacity-0 position-absolute text-center d-flex align-items-center`}
                        >
                          {" "}
                          <span
                            className=" fw-bold position-relative "
                            style={{ width: 20 }}
                          ></span>
                          <span className="icn ms-">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="4"
                              height="4"
                              viewBox="0 0 4 4"
                              fill="none"
                            >
                              <rect
                                x="0.000244141"
                                width="4"
                                height="4"
                                rx="2"
                                fill="#506380"
                              />
                            </svg>
                          </span>{" "}
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexUpFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexUpFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexUpFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexUpFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexUpFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                      </li>
                      <li
                        className="position-relative pt-2 d-none align-items-center justify-content-center"
                        style={{ opacity: 0 }}
                      >
                        <div
                          className={`${styles.listCount} opacity-0 position-absolute text-center d-flex align-items-center`}
                        >
                          {" "}
                          <span
                            className=" fw-bold position-relative "
                            style={{ width: 20 }}
                          ></span>
                          <span className="icn ms-">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="4"
                              height="4"
                              viewBox="0 0 4 4"
                              fill="none"
                            >
                              <rect
                                x="0.000244141"
                                width="4"
                                height="4"
                                rx="2"
                                fill="#506380"
                              />
                            </svg>
                          </span>{" "}
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexUpFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexUpFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexUpFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexUpFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexUpFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                      </li>
                      {game?.lineData &&
                        game?.lineData.length > 0 &&
                        game?.lineData?.map((item, index1) => (
                          <li
                            key={index1}
                            className="position-relative d-flex align-items-center justify-content-center"
                            ref={elementRef}
                            id={`number-${game?.lineData?.length - index1}`}
                          >
                            <div
                              className={`${styles.listCount} ${
                                (!item?.isClicked &&
                                  game?._id &&
                                  game?.lineData &&
                                  game?.lineData?.length -
                                    1 -
                                    game?.lineCount) === index1 && isGameStart
                                  ? styles.active
                                  : ""
                              }
                            position-absolute text-center d-flex align-items-center`}
                            >
                              {" "}
                              <span
                                className=" fw-bold position-relative"
                                style={{ width: 20 }}
                              >
                                {game?.lineData?.length - index1}
                              </span>{" "}
                              <span className="icn ms-">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="4"
                                  height="4"
                                  viewBox="0 0 4 4"
                                  fill="none"
                                >
                                  <rect
                                    x="0.000244141"
                                    width="4"
                                    height="4"
                                    rx="2"
                                    fill="#506380"
                                  />
                                </svg>
                              </span>{" "}
                            </div>
                            {index1 % 2 === 0 && (
                              <div className={`${styles.option}`}>
                                {leftHex}
                              </div>
                            )}
                            {Array.isArray(item?.row) && item?.row?.length
                              ? item?.row.map((data, index2) => {
                                  return (
                                    <div
                                      key={index2}
                                      className={`${styles.option} ${
                                        (!item?.isClicked &&
                                          game?._id &&
                                          game?.lineData &&
                                          game?.lineData?.length -
                                            1 -
                                            game?.lineCount) === index1 &&
                                        styles.active
                                      } ${
                                        data?.isOpened &&
                                        data?.valueType === "bomb"
                                          ? styles.wrongAns
                                          : null
                                      } ${
                                        data?.isOpened &&
                                        data?.valueType !== "bomb"
                                          ? styles.rightAns
                                          : ""
                                      } ${
                                        !data?.isOpened &&
                                        item?.isClicked &&
                                        game?.lineData?.length - 1 <
                                          game?.lineCount <=
                                          index1
                                          ? "opacity-50"
                                          : ""
                                      } position-relative d-flex align-items-center flex-wrap justify-content-center`}
                                      onClick={(e) => {
                                        e?.preventDefault();
                                        if (
                                          (game?.lineData &&
                                            game?.lineData?.length -
                                              1 -
                                              game?.lineCount) !== index1
                                        ) {
                                          return;
                                        }
                                      }}
                                    >
                                      <span
                                        className={`${styles.hexIcn} hexIcn position-absolute`}
                                      >
                                        {!item?.isClicked &&
                                        game?._id &&
                                        game?.lineData &&
                                        game?.lineData.length -
                                          1 -
                                          game?.lineCount ===
                                          index1 &&
                                        isGameStart ? (
                                          <img
                                            src={hexActive}
                                            alt=""
                                            className="img-fluid w-100 activated-hex"
                                          />
                                        ) : data?.isOpened &&
                                          data?.valueType === "jackpot" ? (
                                          <>
                                            <img
                                              src={hexJackpot}
                                              alt=""
                                              className="img-fluid w-100"
                                            />
                                            <span
                                              className={`${styles.hexShadow} hexShadow position-absolute h-auto mx-auto`}
                                              style={{
                                                left: "50%",
                                                top: "50%",
                                                transform:
                                                  "translate(-50%, -50%)",
                                              }}
                                            >
                                              {jackpotShadow}
                                            </span>
                                          </>
                                        ) : data?.isOpened &&
                                          data?.valueType === "bomb" ? (
                                          <>
                                            <img
                                              src={hexWrong}
                                              alt=""
                                              className="img-fluid w-100"
                                            />
                                            <span
                                              className={`${styles.hexShadow} hexShadow position-absolute h-auto mx-auto`}
                                              style={{
                                                left: "50%",
                                                top: "50%",
                                                transform:
                                                  "translate(-50%, -50%)",
                                              }}
                                            >
                                              {redShadow}
                                            </span>
                                          </>
                                        ) : data?.isOpened &&
                                          data?.valueType !== "bomb" &&
                                          data?.valueType !== "jackpot" ? (
                                          <>
                                            <img
                                              src={hexRight}
                                              alt=""
                                              className="img-fluid w-100"
                                            />
                                            <span
                                              className={`${styles.hexShadow} hexShadow position-absolute h-auto mx-auto`}
                                              style={{
                                                left: "50%",
                                                top: "50%",
                                                transform:
                                                  "translate(-50%, -50%)",
                                              }}
                                            >
                                              {blueShadow}
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            <img
                                              src={
                                                item?.isClicked &&
                                                game?.lineData?.length - 1 <
                                                  game?.lineCount &&
                                                index1
                                                  ? hexfade
                                                  : hexDef
                                              }
                                              alt=""
                                              className="img-fluid w-100"
                                            />
                                          </>
                                        )}
                                      </span>

                                      {item.isClicked && (
                                        <>
                                          {typeof data?.value === "number" &&
                                            !isNaN(data?.value) && (
                                              <span
                                                className={`${styles.value} text-white text-center d-block w-100`}
                                              >
                                                {data?.value?.toString()
                                                  .length > 4
                                                  ? data?.value
                                                  : data?.value}
                                              </span>
                                            )}
                                        </>
                                      )}
                                      {item.isClicked && (
                                        <>
                                          {typeof data?.value === "string" &&
                                            data?.value === "jackpot" && (
                                              <span
                                                className={`${styles.txtValue} text-white text-center d-block w-100`}
                                              >
                                                {data?.value?.toUpperCase()}
                                              </span>
                                            )}
                                        </>
                                      )}
                                      {item.isClicked && (
                                        <>
                                          {data?.valueType === "bomb" ? (
                                            <img
                                              src={data?.coinIcon}
                                              alt=""
                                              className="img-fluid object-fit-contain"
                                              style={{ height: "70%" }}
                                            />
                                          ) : (
                                            <img
                                              src={data?.coinIcon}
                                              alt=""
                                              className="img-fluid object-fit-contain"
                                              style={{ height: "50%" }}
                                            />
                                          )}
                                        </>
                                      )}
                                    </div>
                                  );
                                })
                              : ["", "", "", ""].map((_, encRowIndex) => {
                                  return (
                                    <div
                                      key={encRowIndex}
                                      className={`${styles.option}
                                     position-relative d-flex align-items-center flex-wrap justify-content-center`}
                                      onClick={(e) => {
                                        e?.preventDefault();
                                        if (
                                          (game?.lineData &&
                                            game?.lineData?.length -
                                              1 -
                                              game?.lineCount) !== index1
                                        ) {
                                          return;
                                        }
                                        handleClick(index1, encRowIndex, game);
                                      }}
                                    >
                                      <span
                                        className={`${styles.hexIcn} hexIcn position-absolute`}
                                      >
                                        {(!item?.isClicked &&
                                          game?._id &&
                                          game?.lineData &&
                                          game?.lineData?.length -
                                            1 -
                                            game?.lineCount) === index1 &&
                                        isGameStart ? (
                                          <img
                                            src={hexActive}
                                            alt=""
                                            className="img-fluid w-100 activated-hex"
                                          />
                                        ) : (
                                          <>
                                            <img
                                              src={
                                                item?.isClicked &&
                                                game?.lineData?.length - 1 <
                                                  game?.lineCount <=
                                                  index1
                                                  ? hexfade
                                                  : hexDef
                                              }
                                              alt=""
                                              className="img-fluid w-100"
                                            />
                                          </>
                                        )}
                                      </span>
                                    </div>
                                  );
                                })}
                            {index1 % 2 !== 0 && (
                              <div className={`${styles.option}`}>
                                {rightHex}
                              </div>
                            )}
                          </li>
                        ))}
                      <li
                        className="position-relative pt-2 d-flex align-items-center justify-content-center"
                        style={{ opacity: 0.5 }}
                      >
                        <div
                          className={`${styles.listCount} opacity-0 position-absolute text-center d-flex align-items-center`}
                        >
                          {" "}
                          <span
                            className=" fw-bold position-relative "
                            style={{ width: 20 }}
                          ></span>
                          <span className="icn ms-">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="4"
                              height="4"
                              viewBox="0 0 4 4"
                              fill="none"
                            >
                              <rect
                                x="0.000244141"
                                width="4"
                                height="4"
                                rx="2"
                                fill="#506380"
                              />
                            </svg>
                          </span>{" "}
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexDownFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexDownFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexDownFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexDownFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                        <div
                          className={`${styles.option} position-relative d-flex align-items-center flex-wrap justify-content-center`}
                        >
                          <span
                            className={`${styles.hexIcn} hexIcn position-absolute`}
                          >
                            <img
                              src={hexDownFade}
                              alt=""
                              className="img-fluid w-100"
                            />
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Col>
            <Col
              lg="12"
              className={`${styles.ctcWrpper} py-2`}
              style={{
                position: "fixed",
                bottom: 80,
                maxWidth: 430,
                zIndex: 999,
                background: "#0c0c0c",
              }}
            >
              <div
                className={`${styles.ctcBtn} d-flex align-items-end justify-content-between`}
              >
                <div className="">
                  <p className="ps-1 m-0 text-white">
                    {t("game_page.scratcher")}
                  </p>
                  <Button
                    style={{ background: " #242AFC" }}
                    onClick={() => openPopup()}
                    className="d-flex align-items-center justify-content-center w-100 fw-bold text-white"
                  >
                    <img
                      src={promotionTicket}
                      alt="ticket"
                      className="img-fluid w-100"
                    />
                  </Button>
                </div>
                <div className="">
                  <p className="ps-1 m-0 text-white">
                    {t("game_page.leaderboard")}
                  </p>
                  <Button
                    style={{
                      border: "1px solid #FFE93E66",
                      background: "#FFE93E33",
                      width: 65,
                    }}
                    onClick={() => redirectToLeaderBorad()}
                    className="d-flex align-items-center justify-content-center fw-bold"
                  >
                    <img
                      src={trophy}
                      alt=""
                      className="img-fluid w-auto h-auto object-fit-contain"
                    />
                  </Button>
                </div>
                <div className="">
                  <p className="ps-1 m-0 text-white">{t("game_page.snatch")}</p>
                  <Button className="text-white d-flex align-items-center justify-content-center w-100 fw-bold">
                    {totalBTNC || 0}
                  </Button>
                </div>

                {isGameStart ? (
                  <Button
                    disabled={
                      loading ||
                      isLoading ||
                      gameUpdateLoading ||
                      !isGameStart ||
                      isStopExecuting.current ||
                      forceStopClick
                    }
                    onClick={handleEndGame}
                    className="d-flex align-items-center justify-content-center w-100 fw-bold text-white"
                    style={{ background: "#ED4032", maxWidth: 170 }}
                  >
                    {t("game_page.stop")}
                  </Button>
                ) : (
                  <Button
                    disabled={
                      loading ||
                      isLoading ||
                      gameUpdateLoading ||
                      isGameStart ||
                      isClickStartBtn.current
                    }
                    onClick={startGame}
                    className={`${styles.gameBtn} d-flex align-items-center justify-content-center w-100 fw-bold text-white`}
                    style={{ background: "#242AFC" }}
                  >
                    {t("game_page.start")}
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default Game;

const redShadow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="71"
    height="80"
    viewBox="0 0 71 80"
    fill="none"
  >
    <g filter="url(#filter0_f_7_685)">
      <path
        d="M35.7512 5.18576L35.2805 4.9137L34.8099 5.18576L5.52934 22.1111L5.05952 22.3827V22.9254V56.7762V57.3188L5.52934 57.5904L34.8099 74.5158L35.2805 74.7878L35.7512 74.5158L65.0317 57.5904L65.5016 57.3188V56.7762V22.9254V22.3827L65.0317 22.1111L35.7512 5.18576Z"
        stroke="#ED4032"
        strokeWidth="1.88096"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_7_685"
        x="0.357217"
        y="0.0652246"
        width="69.8461"
        height="79.5707"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1.88096"
          result="effect1_foregroundBlur_7_685"
        />
      </filter>
    </defs>
  </svg>
);

const blueShadow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="71"
    height="80"
    viewBox="0 0 71 80"
    fill="none"
  >
    <g filter="url(#filter0_f_7_689)">
      <path
        d="M35.7512 5.18576L35.2805 4.9137L34.8099 5.18576L5.52934 22.1111L5.05952 22.3827V22.9254V56.7762V57.3188L5.52934 57.5904L34.8099 74.5158L35.2805 74.7878L35.7512 74.5158L65.0317 57.5904L65.5016 57.3188V56.7762V22.9254V22.3827L65.0317 22.1111L35.7512 5.18576Z"
        stroke="#232AF7"
        strokeWidth="1.88096"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_7_689"
        x="0.357217"
        y="0.0652246"
        width="69.8461"
        height="79.5707"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1.88096"
          result="effect1_foregroundBlur_7_689"
        />
      </filter>
    </defs>
  </svg>
);

const jackpotShadow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="71"
    height="80"
    viewBox="0 0 71 80"
    fill="none"
  >
    <g filter="url(#filter0_f_7_689)">
      <path
        d="M35.7512 5.18576L35.2805 4.9137L34.8099 5.18576L5.52934 22.1111L5.05952 22.3827V22.9254V56.7762V57.3188L5.52934 57.5904L34.8099 74.5158L35.2805 74.7878L35.7512 74.5158L65.0317 57.5904L65.5016 57.3188V56.7762V22.9254V22.3827L65.0317 22.1111L35.7512 5.18576Z"
        stroke="#FFE898"
        strokeWidth="1.88096"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_7_689"
        x="0.357217"
        y="0.0652246"
        width="69.8461"
        height="79.5707"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1.88096"
          result="effect1_foregroundBlur_7_689"
        />
      </filter>
    </defs>
  </svg>
);

const leftHex = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="63"
    height="73"
    viewBox="0 0 62 72"
    fill="none"
  >
    <path
      d="M30.9795 0L62 18V54L30.9795 72L0 54V18L30.9795 0Z"
      fill="url(#paint0_linear_20_4618)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_20_4618"
        x1="55.2188"
        y1="26.4906"
        x2="-3.43536"
        y2="37.1983"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#13131B" />
        <stop offset="1" stopColor="#13131B" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

const rightHex = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="63"
    height="73"
    viewBox="0 0 62 72"
    fill="none"
  >
    <path
      d="M31 0L62 17.9897V53.9691L31 72L0 53.9691V17.9897L31 0Z"
      fill="url(#paint0_linear_20_4617)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_20_4617"
        x1="-10.5"
        y1="37.2597"
        x2="80"
        y2="37.2597"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F0F13" />
        <stop offset="1" stopColor="#13131B" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
